import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=fdd413e6&scoped=true&"
import script from "./MainFooter.vue?vue&type=script&lang=js&"
export * from "./MainFooter.vue?vue&type=script&lang=js&"
import style0 from "./MainFooter.vue?vue&type=style&index=0&id=fdd413e6&scoped=true&lang=css&"
import style1 from "./MainFooter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd413e6",
  null
  
)

export default component.exports